import { FC } from 'react';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { TbRestore } from 'react-icons/tb';
import { Link } from 'react-router-dom';
import { ActionsIcon } from '../../../../../assets/svg/actions';
import { Chip } from '../../../../../components/chip/chip';
import { IconButton } from '../../../../../components/icon-button/icon-button';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { Tooltip } from '../../../../../features/tooltip/tooltip';
import { buildParams, concatPath } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { ManagerPath, RootPath, TreesPath } from '../../../../../routes/manager/manager-enums';
import { useTreeStore } from '../../../../../store/use-tree-store';
import s from './tree-cards.module.css';

interface Props {
  onEnd?: () => void;
}

export const TreeCards: FC<Props> = () => {
  const { list, isLoadingFetch } = useTreeStore();
  const { t, getLocale } = useLang();
  const { addQueryParams } = useQueryParams();

  if (!list?.length && !isLoadingFetch) {
    return <div>{t('Здесь пока нет деревьев')}</div>;
  }

  return (
    <ul className={s.feature}>
      {list?.map((item) => (
        <li key={item.id} className={s.card}>
          <div className={s.title}>
            <div className={s.inUse}>
              {t('Используется QR')}
              <span>
                {item.qr?.length || 0} {t('шт')}.
              </span>
            </div>
            <HasAccess service="tree" permissions={['write']}>
              {item.is_deleted ? (
                <IconButton
                  tooltip={t('Восстановить')}
                  variant="secondary"
                  size="sm"
                  onClick={() =>
                    addQueryParams({
                      restoreId: String(item.id),
                      restoreName: getLocale(item.name),
                    })
                  }
                >
                  <TbRestore />
                </IconButton>
              ) : (
                <Tooltip
                  triggerWrapperClassName={s.actionsButton}
                  optionsWrapperClassName={s.actions}
                  trigger={<ActionsIcon />}
                  offset={12}
                >
                  <div className={s.actions}>
                    <Link
                      to={
                        concatPath([RootPath.Manager, ManagerPath.Trees, TreesPath.CreateTree]) +
                        buildParams({ id: item.id })
                      }
                    >
                      <IconButton tooltip={t('Редактировать')} size="sm" variant="secondary">
                        <AiOutlineEdit />
                      </IconButton>
                    </Link>
                    <IconButton
                      tooltip={t('Удалить')}
                      size="sm"
                      variant="secondary"
                      onClick={() =>
                        addQueryParams({
                          deleteId: String(item.id),
                          deleteName: getLocale(item.name),
                        })
                      }
                    >
                      <AiOutlineDelete />
                    </IconButton>
                  </div>
                </Tooltip>
              )}
            </HasAccess>
          </div>
          <div className={s.branch}>
            {t('Филиал')}
            {item.branches ? (
              <ul className={s.chips}>
                {item.branches.map((branch) => (
                  <Chip key={branch.id} variant="info">
                    {getLocale(branch.value)}
                  </Chip>
                ))}
              </ul>
            ) : (
              <span>{t('Нет')}</span>
            )}
          </div>

          <div className={s.description}>
            {t('Описание')} <span>{getLocale(item.description) || t('Не указано')}</span>
          </div>
          <span className={s.name}>{getLocale(item.name)}</span>
        </li>
      ))}
      {/* <InfiniteScroll onEnterView={onEnd} /> */}
    </ul>
  );
};
